import React from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  useSidebar,
} from "./sidebar";
import { Search, Package, Palette, Layers, Maximize2 } from "lucide-react";

// Import filter implementation
import { SvarFilterWrapperSleekV2 } from '../../gufram/SvarFilterWrapperSleekV2';

export function FilterSidebar({
  items,
  filters,
  onFiltersChange,
  resultsCount,
}) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";
  
  // Component selector - Only V2
  const renderFilters = () => {
    const commonProps = {
      items,
      filters,
      onFiltersChange,
      resultsCount
    };

    return <SvarFilterWrapperSleekV2 {...commonProps} />;
  };

  return (
    <Sidebar collapsible="icon" side="left">
      {/* Mobile collapsed state: horizontal icon bar */}
      {isCollapsed && (
        <div className="md:hidden flex items-center justify-around h-full px-4">
          <button className="flex flex-col items-center gap-1">
            <Search className="w-5 h-5 text-gray-500" />
            <span className="text-[10px] text-gray-400">Search</span>
          </button>
          <button className="flex flex-col items-center gap-1">
            <Package className="w-5 h-5 text-gray-500" />
            <span className="text-[10px] text-gray-400">Warehouse</span>
          </button>
          <button className="flex flex-col items-center gap-1">
            <Palette className="w-5 h-5 text-gray-500" />
            <span className="text-[10px] text-gray-400">Color</span>
          </button>
          <button className="flex flex-col items-center gap-1">
            <Layers className="w-5 h-5 text-gray-500" />
            <span className="text-[10px] text-gray-400">Usage</span>
          </button>
          <button className="flex flex-col items-center gap-1">
            <Maximize2 className="w-5 h-5 text-gray-500" />
            <span className="text-[10px] text-gray-400">Size</span>
          </button>
        </div>
      )}
      
      {/* Desktop collapsed state OR expanded state (both mobile/desktop) */}
      <SidebarContent className={isCollapsed ? "hidden md:flex" : ""}>
        {isCollapsed ? (
          // Desktop collapsed view - vertical icons with proper sizing
          <div className="flex flex-col items-center gap-4 py-4 w-full">
            <button className="flex flex-col items-center gap-1 min-h-[48px] justify-center">
              <Search className="w-5 h-5 text-gray-500 flex-shrink-0" />
              <span className="text-[9px] text-gray-400 text-center leading-tight whitespace-nowrap">Search</span>
            </button>
            <button className="flex flex-col items-center gap-1 min-h-[48px] justify-center">
              <Package className="w-5 h-5 text-gray-500 flex-shrink-0" />
              <span className="text-[9px] text-gray-400 text-center leading-tight whitespace-nowrap">Warehouse</span>
            </button>
            <button className="flex flex-col items-center gap-1 min-h-[48px] justify-center">
              <Palette className="w-5 h-5 text-gray-500 flex-shrink-0" />
              <span className="text-[9px] text-gray-400 text-center leading-tight whitespace-nowrap">Color</span>
            </button>
            <button className="flex flex-col items-center gap-1 min-h-[48px] justify-center">
              <Layers className="w-5 h-5 text-gray-500 flex-shrink-0" />
              <span className="text-[9px] text-gray-400 text-center leading-tight whitespace-nowrap">Usage</span>
            </button>
            <button className="flex flex-col items-center gap-1 min-h-[48px] justify-center">
              <Maximize2 className="w-5 h-5 text-gray-500 flex-shrink-0" />
              <span className="text-[9px] text-gray-400 text-center leading-tight whitespace-nowrap">Size</span>
            </button>
          </div>
        ) : (
          // Expanded view - full filter component with scrolling
          <div className="overflow-y-auto max-h-[calc(100vh-12rem)] md:max-h-[calc(100vh-8rem)]">
            {renderFilters()}
          </div>
        )}
      </SidebarContent>
      <SidebarFooter className={isCollapsed ? "hidden" : ""}>
        <div className="px-2 py-1 text-xs text-gray-500">
          Results: <span className="font-semibold text-gray-700">{resultsCount}</span>
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
